import React, { useEffect, useMemo, useState } from 'react';
import ConfirmModal from '../../../../src/components/ConfirmModal';
import { indiceMesAtual, mesRefDoIndice, periodoDoAviso, type AteQuando, type AvisoUc } from '../../../../src/lib/avisosUc';
import SeletorAteQuando from './SeletorAteQuando';

interface Props {
    aviso: AvisoUc | null;
    salvando: boolean;
    onCancelar: () => void;
    onConfirmar: (inicio: string, ate: AteQuando) => void;
}

// Renovar, deixar sem prazo ou encurtar um aviso. O início não muda.
const PrazoAvisoModal: React.FC<Props> = ({ aviso, salvando, onCancelar, onConfirmar }) => {
    const { inicio, meses, atual } = useMemo(() => {
        if (!aviso) return { inicio: '', meses: [] as string[], atual: { tipo: 'sem_prazo' } as AteQuando };
        const { ini, fim } = periodoDoAviso(aviso);
        const primeiro = ini ?? indiceMesAtual();
        // Do início do aviso até 12 meses depois do mês que está sendo faturado.
        const ultimo = Math.max(indiceMesAtual() + 12, fim ?? 0, primeiro);
        const lista = Array.from({ length: ultimo - primeiro + 1 }, (_, k) => mesRefDoIndice(primeiro + k));
        const ate: AteQuando = fim === null ? { tipo: 'sem_prazo' } : fim === primeiro ? { tipo: 'so_este' } : { tipo: 'ate', mes: mesRefDoIndice(fim) };
        return { inicio: mesRefDoIndice(primeiro), meses: lista, atual: ate };
    }, [aviso]);

    const [valor, setValor] = useState<AteQuando>(atual);
    useEffect(() => { setValor(atual); }, [atual]);

    return (
        <ConfirmModal
            isOpen={!!aviso}
            onClose={() => { if (!salvando) onCancelar(); }}
            onConfirm={() => onConfirmar(inicio, valor)}
            title="Alterar prazo do aviso"
            message={`O aviso começa em ${inicio}. Até quando ele vale?`}
            confirmLabel="Salvar prazo"
            variant="info"
            loading={salvando}
        >
            <SeletorAteQuando meses={meses} inicio={inicio} valor={valor} onChange={setValor} />
        </ConfirmModal>
    );
};

export default PrazoAvisoModal;
